export default __webpack_public_path__ + "static/media/thirstforblood.7afda569.png";